import * as types from './account-projects.types';
export const accountProjectsPageSelectors: types.IAccountProjectsPageSelectors = {
  selectAccountProjects: (state) => state.page.accountProjects.accountProjectIds,
};
